module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.item.dname) + " "), _c('span', [_c('img', {
    staticStyle: {
      "height": "10px",
      "margin-right": "4px"
    },
    attrs: {
      "src": "https://api.opendota.com/apps/dota2/images/tooltips/gold.png"
    }
  }), _vm._v(_vm._s(_vm.item.cost))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.notes))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.item.desc))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.lore))])]), _vm._v(" "), _c('div', _vm._l((_vm.item.attrib), function(attr) {
    return _c('p', [_c('span', [_vm._v(_vm._s(attr.header))]), _c('span', [_vm._v(_vm._s(attr.value))]), _vm._v(" "), (attr.footer) ? _c('span', [_vm._v(_vm._s(attr.footer))]) : _vm._e()])
  })), _vm._v(" "), _c('div', [(_vm.item.mc) ? _c('span', [_c('img', {
    staticStyle: {
      "height": "10px",
      "margin-right": "4px"
    },
    attrs: {
      "src": "https://api.opendota.com/apps/dota2/images/tooltips/mana.png"
    }
  }), _vm._v(_vm._s(_vm.item.mc))]) : _vm._e(), _vm._v(" "), (_vm.item.cd) ? _c('span', [_c('img', {
    staticStyle: {
      "height": "10px",
      "margin-right": "4px"
    },
    attrs: {
      "src": "https://api.opendota.com/apps/dota2/images/tooltips/cooldown.png"
    }
  }), _vm._v(_vm._s(_vm.item.cd))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bfb2c3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemTooltip.vue
// module id = 136
// module chunks = 1